import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { FlashMessageProvider } from "./providers/FlashMessageProvider";
import { ReferenceNumberProvider } from "./providers/ReferenceNumberProvider";
import UserInfoProvider from "./providers/UserInfoProvider";
import reportWebVitals from "./reportWebVitals";
import "./sass/main.scss";

const element = document.getElementById("ya-refcalc-root");
const root = createRoot(element!);
root.render(
  <React.StrictMode>
    <UserInfoProvider>
      <FlashMessageProvider>
        <ReferenceNumberProvider>
          <App />
        </ReferenceNumberProvider>
      </FlashMessageProvider>
    </UserInfoProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
